import helpers from '@/util/helpers';
import { store } from '../../store';
import $http from '@/http';
import channelType from '@/constants/callChannelType';

const getDefaultState = () => {
  return {
    callServerType: null,
    callApiUrl: '',
    callWebsocketUrl: '',
    callStatusUrl: '',
    callMode: 'NEOMECCA',
    callPort: '3025'
  };
};
const state = getDefaultState();

const getters = {
  callApiUrl: (state) => {
    return state.callApiUrl;
  },
  callWebsocketUrl: (state) => {
    return state.callWebsocketUrl;
  },
  callStatusUrl: (state) => {
    return state.callStatusUrl;
  },
  callMode: (state) => {
    return state.callMode;
  },
  getCallServerType: (state) => {
    return state.callServerType;
  },
  callPort: (state) => {
    return state.callPort;
  },
  isKtOrKlcns: (state) => {
    const arr = [channelType.KT, channelType.KLCNS];
    return arr.indexOf(state.callMode) > -1;
  },
  isNeomecca: (state) => {
    return state.callMode === channelType.NEOMECCA;
  },
  isNeoWebRtc: (state) => {
    return state.callMode === channelType.NEO_WEB_RTC;
  },
  isKt: (state) => {
    return state.callMode === channelType.KT;
  },
  isKlcns: (state) => {
    return state.callMode === channelType.KLCNS;
  }
};

const mutations = {
  setCallStatus(state) {
    state.callStatusUrl = helpers.findCallStatusUrl();
  },
  setCallServerType(state, payload) {
    state.callServerType = payload;
  },
  changeCallWebSocketUrl(state) {
    const callWebsocketUrl = helpers.findCallWebsocketUrl(state.callServerType);
    state.callWebsocketUrl = callWebsocketUrl ? callWebsocketUrl + ':' + state.callPort : callWebsocketUrl;
  },
  setCallWebSocketUrl(state, payload) {
    state.callWebsocketUrl = payload;
  },
  setCallMode(state, payload) {
    state.callMode = payload;
  },
  setCallPort(state, port) {
    state.callPort = port;
  },
  setCallApiUrl(state, payload) {
    state.callApiUrl = payload;
  },
  CLEAR_CALL_SERVER(state) {
    state.callServerType = null;
    state.callApiUrl = '';
    state.callWebsocketUrl = '';
    state.callStatusUrl = '';
    state.callMode = channelType.NEOMECCA;
    state.callPort = '3025';
  }
};

const actions = {
  recheckCallServerAndRefresh() {
    // 상담사 로그인한 상태에서
    // 관리자가 콜 채널을 승인할 경우,
    // 브랜드 리스트를 순회하면서 채널 승인 여부를 체크한 뒤
    // 신규 승인된 콜 채널이 있을 경우 새로고침한다.
    const { getBrands, getWorkplace } = store.getters;

    // 네오메카 콜 분리 버전이면 콜 체크가 필요하지 않으므로 아래 api 호출은 무시한다.
    if (getWorkplace.callChannelType && getWorkplace.callChannelType.code === 'NEOMECCA') return;

    if (getBrands && getBrands.length > 0) {
      getBrands.forEach((brand) => {
        $http({
          url: '/api/module/fetchCallModuleData',
          method: 'GET',
          params: {
            brandId: brand.id
          },
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then((result) => {
          if (result.data.code === 0 && result.data.data && helpers.isObjectNotEmpty(result.data.data)) {
            store.dispatch('refresh');
          }
        });
      });
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/call/callServer.js